import { useMemo, useCallback, memo } from 'react';

import { useCalendarContext } from './Calendar.utils';
import { Select } from '../Select';

const YearDropdownBase = ({ className }: { className?: string }) => {
  const state = useCalendarContext();

  // to the current locale and calendar system.
  const years = useMemo(() => {
    const minYear = state.minValue?.year ?? 1920;
    const maxYear = state.maxValue?.year ?? new Date().getFullYear() + 100;

    const yearOptions = [];

    for (let year = minYear; year <= maxYear; year++) {
      const date = state.focusedDate.set({ year });
      yearOptions.push({
        value: year,
        label: date.toDate(state.timeZone).getFullYear(),
      });
    }

    return yearOptions;
  }, [state]);

  const handleSelectionChange = useCallback(
    (value: number | null | undefined) => {
      if (!value) return;

      state.setFocusedDate(state.focusedDate.set({ year: value }));
    },
    [state],
  );

  return (
    <Select
      value={state.focusedDate.year}
      menuClassName="max-h-[240px]"
      className={className}
      options={years}
      placeholder="Year"
      variant="simple"
      onValueChange={handleSelectionChange}
      autoFocusItem
    />
  );
};

export const YearDropdown = memo(YearDropdownBase);
